import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// Site::Lp06::Question::Component の Stimulus コントローラ。
// landIeul: openStates トグル。top/bottom の Lp06_opend / Lp06_closed を切り替える。
const OPEND = "Lp06_opend";
const CLOSED = "Lp06_closed";

class SiteLp06QuestionController extends Controller {
  static targets = ["top", "bottom"];

  declare readonly topTarget: HTMLElement;
  declare readonly bottomTarget: HTMLElement;

  toggle(): void {
    const open = !this.topTarget.classList.contains(OPEND);
    [this.topTarget, this.bottomTarget].forEach((el) => {
      el.classList.toggle(OPEND, open);
      el.classList.toggle(CLOSED, !open);
    });
  }
}

application.register("site--lp06--question", SiteLp06QuestionController);
